export const UPDATE_CCAVENUE_TXNS_STATUS = "UPDATE_CCAVENUE_TXNS_STATUS";
export const RESET_CCAVENUE_TXNS_STATUS = "RESET_CCAVENUE_TXNS_STATUS";
